"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnEdgeProximityDetect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useOnEdgeProximityDetect = _ref => {
  let {
    triggerRef,
    wrapperRef,
    contentRef,
    requiresRecalc
  } = _ref;
  const xAxisOverride = _ref2 => {
    let {
      left,
      width,
      clientWidth
    } = _ref2;
    // Too close to left
    if (left < 0) {
      return 'shiftRight';
    }

    // Too close to right
    if (left + width > clientWidth) {
      return 'shiftLeft';
    }
    return '';
  };
  const yAxisOverride = _ref3 => {
    let {
      top,
      height,
      clientHeight
    } = _ref3;
    // Too close to top
    if (top - height < 0) {
      return 'shiftDown';
    }

    // Too close to bottom
    if (top + height > clientHeight) {
      return 'shiftUp';
    }
    return '';
  };
  (0, _react.useEffect)(() => {
    if (wrapperRef.current && contentRef.current && triggerRef.current && document && document.body) {
      wrapperRef.current.classList.add('measuring');
      const {
        clientWidth,
        clientHeight
      } = document.body;
      const {
        width,
        height,
        top,
        left
      } = contentRef.current.getBoundingClientRect();

      // TODO: Check it can still fit when flipped.
      const xAxisOverrideCssClass = xAxisOverride({
        left,
        width,
        clientWidth
      });
      if (xAxisOverrideCssClass) {
        wrapperRef.current.classList.add(xAxisOverrideCssClass);
      }
      const yAxisOverrideCssClass = yAxisOverride({
        top,
        height,
        clientHeight
      });
      if (yAxisOverrideCssClass) {
        wrapperRef.current.classList.add(yAxisOverrideCssClass);
      }
      wrapperRef.current.classList.remove('measuring');
    }
  }, [triggerRef, wrapperRef, contentRef, requiresRecalc]);
  return {};
};
exports.useOnEdgeProximityDetect = useOnEdgeProximityDetect;
useOnEdgeProximityDetect.propTypes = {
  triggerRef: _propTypes.default.element.isRequired,
  wrapperRef: _propTypes.default.element.isRequired,
  contentRef: _propTypes.default.element.isRequired,
  preferredPlacement: _propTypes.default.oneOf(['right-middle', 'right-top', 'right-bottom', 'left-middle', 'left-top', 'left-bottom', 'top-middle', 'top-top', 'top-bottom', 'bottom-middle', 'bottom-top', 'bottom-bottom'])
};